import Breadcrumb from "../../../components/Breadcrumb";
import {
  AcceptIcon,
  CloseIcon,
  MergedTicketIcon,
  Pdf,
  TicketsDetailIcon,
  TicketsGrayIcon,
} from "../../../icons";
import "../style.scss";
import TagComp from "../../../components/tag";
import { Dropdown, Image, message } from "antd";

import { useNavigate } from "react-router";
import { useCallTypes } from "../../../hooks/useCallTypes";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import React, { useEffect, useState } from "react";
import ChangeStatusModal from "../../../components/ModalLayout/components/ChangeStatusModal";
import ConfirmModal from "../../../components/ModalLayout/components/ConfirmModal";
import { useUpdateTicketStatus } from "../../../hooks/useUpdateTicketStatus";
import { useAssignTicket } from "../../../hooks/useAssignTicket";
import { AssignIcon, StatusIcon } from "../../../layout/Components/icons";
import { isPermit } from "../../../utils/permissionCheck";
import ServiceRequestDrawer from "../../../components/DrawerLayout/components/ServiceRequestList";
import ContractServicesDrawer from "../../../components/DrawerLayout/components/ContactServicesList/index";
import Button from "../../../components/button";
import type { TicketProduct } from "../type";
import { useTickets } from "../../../hooks/useTickets";
import AcceptTicket from "../../../components/ModalLayout/components/AcceptTicket";
import { useTicketApproval } from "../../../hooks/useTicketDetails";

dayjs.extend(duration);
dayjs.extend(utc);
interface LeftSectionProps {
  currentPage?: string;
  ticketData?: any;
  accountData?: any;
  pikitupServices?: any;
  pikitupMeta?: any;
  ticketType: "None" | "Primary" | "Merged";
  onSwitchToPrimary?: () => void;
  refetchTickets: () => void;
}
interface Ticket {
  id?: number;
  pikitup_ticket_id?: number;
  service_ticket_no?: string;
  service_short_description?: string;
  service_long_description?: string;
  additional_details?: string;
  service_id?: number;
  service_type?: number;
  service_address_info?: string;
  ticket_owner_name?: string;
  customer_reference_no?: string;
  customer_contact_number?: string;
  email?: string;
  files?: { pikitup_ticket_image_id: number; filepath: string }[];
  status_flg?: number;
  admin_internal_status?: number;
}
interface Section {
  title: string;
  items: { label: string; value: string }[];
}

interface ServiceDetail {
  productName: string;
  quantity: string;
  material: string;
  colour: string;
  dimension: string;
  image: string;
}

// interface Comment {
//   author: string;
//   date: string;
//   content: string;
//   refetchTickets: () => void;
// }

type TicketStatus =
  | "Resolved"
  | "Completed"
  | "Ongoing"
  | "Closed"
  | "Unassigned"
  | "Pending";

const LeftSection: React.FC<LeftSectionProps> = ({
  ticketType,
  ticketData,
  accountData,
  pikitupServices,
  pikitupMeta,
  refetchTickets,
}) => {
  const navigate = useNavigate();
  const [assignConfirmOpen, setAssignConfirmOpen] = useState(false);
  const [changeStatusModalOpen, setChangeStatusModalOpen] = useState(false);
  const [, setSelectedRowKeys] = useState<any[]>([]);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openParkedModal, setOpenParkedModal] = useState(false);
  const [openReinitiateModal, setOpenReinitiateModal] = useState(false);
  const [, setSelectedTicketId] = useState<number | null>(null);
  const [servicedrawerOpen, setServiceDrawerOpen] = useState(false);
  const [ContactServicesDrawer, setContactDrawerOpen] = useState(false);
  const [acceptTicketOpen, setAcceptTicketOpen] = useState(false);
  const [isPaymentRequired, setIsPaymentRequired] =
    useState<string>("with_payment");

  const [requestedQty, setRequestedQty] = useState(
    ticketData?.ticket_products?.[0]?.requested_count || 0
  );

  const [approvedQty, setApprovedQty] = useState(
    ticketData?.ticket_products?.[0]?.requested_count || 0
  );

  const storedUserRaw = localStorage.getItem("Data");
  let storedUser: any = {};
  try {
    storedUser = storedUserRaw ? JSON.parse(storedUserRaw) : {};
  } catch (e) {
    storedUser = {};
  }
  // const handleRejectClick = (ticketId: number) => {
  //   setSelectedTicketId(ticketId);
  //   setOpenRejectModal(true);
  // };

  // const handleParkedClick = (ticketId: number) => {
  //   setSelectedTicketId(ticketId);
  //   setOpenParkedModal(true);
  // };

  const attachmentsToUse = Array.isArray(ticketData?.files)
    ? ticketData.files
    : [];
  const getFileName = (path?: string) => {
    if (!path) return "";
    return path.split("/").pop()?.split("?")[0] || "";
  };

  const CALL_TYPES = [
    {
      service_id: 30016,
      call_type: "Street cleaning",
      service_desc: "Street not cleaned",
    },
    {
      service_id: 30019,
      call_type: "Missed collection",
      service_desc: "Collections not picked up",
    },
    {
      service_id: 30020,
      call_type: "Property damaged(pickitup) (domestic)",
      service_desc: "Pikitup damage to property (domestic)",
    },
    {
      service_id: 30021,
      call_type: "Illegal dumping",
      service_desc: "Pikitup illegal dumping",
    },
    {
      service_id: 30006,
      call_type: "Dead animal removal",
      service_desc: "Pikitup dead animals removal",
    },
  ];

  const callTypeValue =
    CALL_TYPES.find((ct) => ct.service_id === ticketData?.service_id)
      ?.call_type || "-";
  const breadcrumbItems = [
    {
      title: (
        <span
          onClick={() => navigate("/tickets")}
          className="breadcrumb-first flex gap-1"
        >
          <TicketsGrayIcon /> Tickets
        </span>
      ),
    },
    {
      title: (
        <span className="breadcrumb-second flex gap-1">
          <TicketsDetailIcon />{" "}
          {ticketData?.service_short_description || "Ticket Details"}
        </span>
      ),
    },
  ];
  const EXCLUDED_STATUSES = ["Rejected", "Closed", "Resolved", "Parked"];

  const memberType = storedUser?.data?.member_type ?? storedUser?.membertype;

  const isMemberType3 = Number(memberType) === 3;
  // const ActionMenu = (record: Ticket) => {
  //   const items: any[] = [];

  //   // Assign Ticket: show only if status is 1
  //   if (Number(record.status_flg) === 1 && isPermit(2, "assign")) {
  //     items.push({
  //       key: "assign",
  //       label: (
  //         <span className="flex justify-start items-center">
  //           <span style={{ marginRight: 8 }}>
  //             <AssignIcon />
  //           </span>
  //           Assign Ticket
  //         </span>
  //       ),
  //       onClick: () => {
  //         setSelectedRowKeys([record.id]);
  //         setAssignConfirmOpen(true);
  //       },
  //     });
  //   }

  //   // ✅ Change Status: show only if NOT in excluded statuses
  //   const currentStatusLabel = STATUS_MAP[record.status_flg?.toString()] || "";
  //   if (
  //     !EXCLUDED_STATUSES.includes(currentStatusLabel) &&
  //     isPermit(2, "edit")
  //   ) {
  //     items.push({
  //       key: "reject",
  //       label: (
  //         <span className="flex justify-start items-center text-red-600">
  //           <span style={{ marginRight: 8 }}>
  //             <StatusIcon />
  //           </span>
  //           Reject
  //         </span>
  //       ),
  //       onClick: () => {
  //         setSelectedTicketId(record.id);
  //         setOpenRejectModal(true);
  //       },
  //     });

  //     {
  //       !isMemberType3 &&
  //         isPermit(2, "edit") &&
  //         items.push({
  //           key: "parked",
  //           label: (
  //             <span className="flex justify-start items-center text-yellow-600">
  //               <span style={{ marginRight: 8 }}>
  //                 <StatusIcon />
  //               </span>
  //               Parked
  //             </span>
  //           ),
  //           onClick: () => {
  //             setSelectedTicketId(record.id);
  //             setOpenParkedModal(true);
  //           },
  //         });
  //     }
  //   }

  //   return { items };
  // };

  const { mutate: updateTicketStatusMutate, isPending: isUpdating } =
    useUpdateTicketStatus();
  const { mutate: assignTicketMutate, isPending: isAssigning } =
    useAssignTicket();

  const { mutate: approveTicket, isPending: isApproving } = useTicketApproval();

  const handleApproval = () => {
    const showPaymentOption =
      ticketData?.service_id === 30007 ||
      ticketData?.service_id === 30011 ||
      ticketData?.service_id === 30009 ||
      ticketData?.service_id === 30013;
    const payload: any = {
      pikitup_ticket_id: ticketData?.pikitup_ticket_id,

      product_details: [
        {
          pickup_ticket_product_detail_id:
            ticketData?.ticket_products?.[0]?.pickup_ticket_product_detail_id,
          requested_count: Number(requestedQty),
          approved_count: Number(approvedQty),
        },
      ],
    };
    if (showPaymentOption) {
      payload.is_payment_required = isPaymentRequired === "with_payment";
    }

    approveTicket(payload, {
      onSuccess: () => {
        message.success("Ticket approved successfully");
        refetchTickets?.();
        setAcceptTicketOpen(false);
      },
      onError: () => {
        message.error("Failed to approve ticket");
      },
    });
  };

  const sections: Section[] = [
    {
      title: "Other ticket details",
      items: [
        {
          label: "Ticket type",
          value:
            ticketData?.service_type === 2 ? "Incident" : "Service Request",
        },
        { label: "Call type", value: callTypeValue },
        { label: "Created on", value: ticketData?.created_date || "-" },
        { label: "Location", value: ticketData?.service_address_info || "-" },
        { label: "Owned by", value: ticketData?.ticket_owner_name || "-" },
        { label: "Assignee name", value: ticketData?.assignee_name || "-" },

        {
          label: "Unit Group",
          value: ticketData?.unit_group_name?.toString() || "-",
        },
      ],
    },
    {
      title: "Customer details",
      items: [
        {
          label: "Name",
          value:
            `${ticketData?.customer_first_name ?? ""} ${
              ticketData?.customer_surname ?? ""
            }`.trim() || "-",
        },
        {
          label: "Reference number",
          value: ticketData?.customer_reference_no || "-",
        },
        { label: "Address", value: ticketData?.service_address_info || "-" },
        {
          label: "Contact number",
          value: ticketData?.customer_contact_number || "-",
        },
        {
          label: "Email ID",
          value: ticketData?.email || "-",
        },
      ],
    },
    {
      title: "Property details",
      items: [
        {
          label: "Property owner",
          value: accountData?.property_owner || "-",
        },
        {
          label: "Account number",
          value: accountData?.account_no || "-",
        },
        {
          label: "Property type",
          value: accountData?.property_type || "-",
        },
        {
          label: "Property address",
          value: accountData?.property_address || "-",
        },
        {
          label: "Contact number",
          value: accountData?.contact_no || "-",
        },
        {
          label: "Email ID",
          value: accountData?.email || "-",
        },
      ],
    },
  ];

  const serviceDetails: ServiceDetail[] =
    ticketData?.ticket_products?.map((product: TicketProduct) => {
      const imageUrl = product.product_images?.[0]?.filepath || null;

      return {
        productName: product.product_name,
        quantity: `${product.requested_count} pieces`,
        material: product.material,
        colour: product.colour,
        dimension: product.dimensions,
        image: imageUrl, // <- updated here
      };
    }) || [];

  const descriptionData = {
    title: "Ticket Description",
    description: ticketData?.service_long_description || "-",
    additionalTitle: "Additional details:",
    additionalDescription: ticketData?.additional_details || "-",
  };

  // const statusClassMap: Record<TicketStatus, string> = {
  //   Resolved: "ant-tag-green",
  //   Completed: "ant-tag-cyan",
  //   Ongoing: "ant-tag-ongoing ",
  //   Closed: "ant-tag-red",
  //   Unassigned: "ant-tag-volcano",
  //   Pending: "ant-tag-orange",
  // };

  const STATUS_MAP: Record<string, string> = {
    "1": "New",
    "28": "Not Initiated",
    "10": "Initiated",
    "31": "Parked",
    "23": "Rejected",
    "6": "Resolved",
    "3": "Closed",
  };

  const status = ticketData?.status_flg?.toString() || "1"; // derive safely
  const label = STATUS_MAP[status] || "";
  const statusClass = label.toLowerCase().replace(/\s+/g, "-");
  const hideActionButtons = ["23", "3", "6"].includes(status);
  const referenceNo = ticketData?.customer_reference_no; // Direct access
  const serviceType = ticketData?.service_type;

  const shouldFetch = serviceType === 1 && referenceNo;
  const [searchKey, setSearchKey] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const baseFilters = {
    ticket_type_in: [serviceType],
    reference_no: referenceNo,
    status: -1,
  };

  const filters = {
    ...baseFilters,
    ...(searchKey ? { service_ticket_no: searchKey, search: true } : {}),
    ...(selectedAccount !== "All" ? { account_no: selectedAccount } : {}),
  };

  // In TicketDetails component
  const { data: serviceHistory, isLoading } = useTickets(
    filters,
    true,
    currentPage,
    10
  );

  // const ticketStatus: TicketStatus = "Ongoing";
  // const shouldShowComments = ticketType !== "Merged";

  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => t + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const showUnassignedTimer =
    (ticketData.status_flg === 28 ||
      ticketData.status_flg === 10 ||
      ticketData.status_flg === 1) &&
    ticketData.created_date;

  const showUnassignedTimerResponse =
    (ticketData.status_flg === 28 || ticketData.status_flg === 1) &&
    ticketData.created_date;

  const formatCountdown = (targetTime: string) => {
    const now = dayjs();
    const escalationTime = dayjs(targetTime, "DD-MM-YYYY HH:mm:ss");

    // Calculate difference in seconds
    const diff = escalationTime.diff(now, "second");
    const dur = dayjs.duration(diff, "seconds");

    //  Use total hours across days (not just within 24h)
    const hours = Math.floor(dur.asHours());
    const minutes = dur.minutes();
    const seconds = dur.seconds();

    // Format properly
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  // Response SLA
  const getUnassignedStatusResponse = () => {
    const { response_sla_escalation_time, response_sla_overdue } =
      ticketData || {};

    if (!response_sla_escalation_time) return null;

    const escalationTime = dayjs(
      response_sla_escalation_time,
      "DD-MM-YYYY HH:mm:ss"
    );
    const countdown = formatCountdown(response_sla_escalation_time);

    if (response_sla_overdue || dayjs().isAfter(escalationTime)) {
      return (
        <div className="sla_container">
          Response: <span className="breached">Breached</span>
        </div>
      );
    }

    return (
      <div className="sla_container">
        Response: <span className="timer">{countdown}</span>
      </div>
    );
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [searchKey, selectedAccount]);

  const isImageFile = (mime?: string) => !!mime && mime.startsWith("image/");

  const isPdfFile = (mime?: string) => mime === "application/pdf";

  // Resolution SLA
  const getUnassignedStatusResolution = () => {
    const { resolution_sla_escalation_time, resolution_sla_overdue } =
      ticketData || {};

    if (!resolution_sla_escalation_time) return null;

    const escalationTime = dayjs(
      resolution_sla_escalation_time,
      "DD-MM-YYYY HH:mm:ss"
    );
    const countdown = formatCountdown(resolution_sla_escalation_time);

    if (resolution_sla_overdue || dayjs().isAfter(escalationTime)) {
      return (
        <div className="sla_container">
          Resolution: <span className="breached">Breached</span>
        </div>
      );
    }

    return (
      <div className="sla_container">
        Resolution: <span className="timer">{countdown}</span>
      </div>
    );
  };

  return (
    <div className="left-details-frame">
      <div className="header-wrapper flex flex-col gap-4">
        <Breadcrumb items={breadcrumbItems} />
        <div className="ticket-heading-wrapper flex gap-3 items-baseline">
          <h3 className="heading">{ticketData.service_short_description}</h3>

          {ticketType !== "None" && (
            <div className="ticket-type flex items-center">
              {ticketType === "Merged" && (
                <span className="ticket-type-icon merged-ticket-wrap">
                  <MergedTicketIcon />
                </span>
              )}
              {/* {ticketType === "Primary" && (
                <span className="ticket-type-icon primary-ticket-wrap">
                  <PrimaryTicketIcon />
                </span>
              )} */}
            </div>
          )}

          <div className="tag-wrapper flex gap-3 items-center">
            <TagComp className="ant-tag-ticket">
              {ticketData.service_ticket_no}
            </TagComp>
            <div className="tag-wrapper flex gap-3 items-center">
              <span className={`status-pill status-${statusClass}`}>
                {label}
              </span>
            </div>
          </div>

          <div className="flex  gap-1 mt-2">
            {showUnassignedTimerResponse && getUnassignedStatusResponse()}
            {showUnassignedTimer && getUnassignedStatusResolution()}
          </div>

          {!hideActionButtons && (
            <div className="button-wrapper flex gap-2 ml-4">
              {ticketData?.status_flg !== 31 && (
                <Button
                  iconPosition="start"
                  icon={<AcceptIcon />}
                  btnSize="sm"
                  className="ant-btn-tertiary ticket-details-btn"
                  onClick={() => {
                    setOpenParkedModal(true);
                  }}
                >
                  Parked
                </Button>
              )}
              {ticketData?.status_flg === 31 && (
                <Button
                  btnSize="sm"
                  className="ant-btn-tertiary ticket-details-btn"
                  onClick={() => {
                    setOpenReinitiateModal(true);
                  }}
                >
                  Re-initiate
                </Button>
              )}
              {ticketData?.service_type === 1 &&
                ticketData?.status_flg == 1 && (
                  <Button
                    iconPosition="start"
                    icon={<AcceptIcon />}
                    btnSize="sm"
                    className="ant-btn-tertiary ticket-details-btn"
                    onClick={() => {
                      setAcceptTicketOpen(true);
                    }}
                  >
                    Accept
                  </Button>
                )}

              {/* {ticketData?.service_type !== 1 &&
                ticketData?.status_flg !== 28 && (
                  <Button
                    iconPosition="start"
                    icon={<AssignIcon />}
                    btnSize="sm"
                    className="ant-btn-tertiary ticket-details-btn"
                    onClick={() => {
                      setAssignConfirmOpen(true);
                    }}
                  >
                    Assign Ticket
                  </Button>
                )} */}

              <Button
                iconPosition="start"
                icon={<CloseIcon />}
                btnSize="sm"
                className="ant-btn-tertiary ticket-details-btn reject-btn"
                onClick={() => {
                  setOpenRejectModal(true);
                }}
              >
                reject
              </Button>
            </div>
          )}

          {/* {ActionMenu(ticketData).items.length > 0 && isPermit(2, "edit") && (
            <div className="ml-auto">
              <Dropdown
                menu={{ items: ActionMenu(ticketData).items }}
                trigger={["click"]}
              >
                <MoreOutlined
                  style={{
                    fontSize: "22px",
                    cursor: "pointer",
                    minWidth: "20px",
                  }}
                />
              </Dropdown>
            </div>
          )} */}
        </div>
        <div className="details-wrapper flex flex-col gap-6 mt-6">
          <div className="ticket-description-card mt-4">
            <h4 className="details-card-heading mb-2">
              {descriptionData.title}
            </h4>
            <p className="description mb-3">{descriptionData.description}</p>
            <span className="additional-heading mb-1">
              {descriptionData.additionalTitle}
            </span>
            <p className="description">
              {descriptionData.additionalDescription}
            </p>
          </div>
          {/* Ticket request Section */}
          {ticketData?.ticket_products?.length > 0 && (
            <div className="service-section bg-gray-50 p-4 rounded-md shadow">
              <div className="flex justify-between items-center">
                <h4 className="details-card-heading">Ticket request </h4>
              </div>

              <div className="flex flex-col gap-3">
                {serviceDetails.map((service, idx) => (
                  <div key={idx} className="container">
                    <img
                      src={service.image}
                      alt={service.productName}
                      className="w-[70px] h-[70px] object-cover rounded-md"
                    />

                    <div className="grid grid-cols-3 gap-4 flex-1 text-[14px] leading-[20px]">
                      <div>
                        <span className="label">Product Name</span>
                        <span className="value">{service.productName}</span>
                      </div>

                      <div>
                        <span className="label">Quantity</span>
                        <span className="value">{service.quantity}</span>
                      </div>
                      <div>
                        <span className="label">Dimension</span>
                        <span className="value">{service.dimension}</span>
                      </div>
                      <div>
                        <span className="label">Material</span>
                        <span className="value">{service.material}</span>
                      </div>

                      <div>
                        <span className="label">Colour</span>
                        <span className="value">{service.colour}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {sections.map((section, index) => {
            // "Property details" section if service_type is 2
            if (
              section.title === "Property details" &&
              ticketData?.service_type === 2
            ) {
              return null;
            }

            return (
              <div
                key={index}
                className="section-card bg-gray-50 p-4 rounded-md shadow"
              >
                <div className="flex justify-between">
                  <h4 className="details-card-heading mb-3">{section.title}</h4>
                  {section.title === "Customer details" &&
                    ticketData?.service_type !== 2 && (
                      <span
                        onClick={() => setServiceDrawerOpen(true)}
                        className="font-normal text-[15px] leading-[110%] text-[#377a86] underline cursor-pointer"
                      >
                        Service request history
                      </span>
                    )}
                  {section.title === "Property details" &&
                    ticketData?.ticket_products?.length > 0 && (
                      <span
                        onClick={() => setContactDrawerOpen(true)}
                        className="font-normal text-[15px] leading-[110%] text-[#377a86] underline cursor-pointer"
                      >
                        Pickitup service lists
                      </span>
                    )}
                </div>
                <div className="grid grid-cols-2 gap-4">
                  {section.items.map((item, idx) => (
                    <div key={idx} className="flex flex-col">
                      <span className="text-sm text-gray-500">
                        {item.label}
                      </span>
                      <span className="font-medium">{item.value}</span>
                    </div>
                  ))}
                </div>
                {section.title === "Other ticket details" && (
                  <>
                    <hr className="mb-4 mt-4 border-t border-[#EBEAE3]" />
                    {/* {ticketData?.files?.length > 0 && ( */}
                    <div className="attachments-wrapper mt-6">
                      <span className="details-card-heading">Attachments</span>

                      <Image.PreviewGroup
                        items={attachmentsToUse
                          .filter((file: { filepath: string }) =>
                            file.filepath?.match(
                              /\.(jpg|jpeg|png|gif|webp|svg)$/i
                            )
                          )
                          .map((file: { filepath: any }) => ({
                            src: file.filepath,
                          }))}
                      >
                        <div className="attachments-list flex gap-3 mt-3">
                          {attachmentsToUse.slice(0, 3).map((file, idx) => {
                            const isImage = isImageFile(file.file_mimetype);
                            const isPdf = isPdfFile(file.file_mimetype);

                            return (
                              <div
                                key={file.pikitup_ticket_image_id}
                                className={`attachment-item ${
                                  idx === 2 && attachmentsToUse.length > 3
                                    ? "has-overlay"
                                    : ""
                                }`}
                                onClick={() => {
                                  if (!isImage && file.filepath) {
                                    window.open(
                                      file.filepath,
                                      "_blank",
                                      "noopener,noreferrer"
                                    );
                                  }
                                }}
                                style={{
                                  cursor: !isImage ? "pointer" : "default",
                                }}
                              >
                                {isImage ? (
                                  <Image
                                    src={file.filepath}
                                    width={184}
                                    height={178}
                                    className="attachment-img"
                                  />
                                ) : (
                                  <div className="attachment-pdf border border-1">
                                    <Pdf height={35} width={25} />
                                    <span className="text-sm truncate px-2">
                                      {getFileName(file.filepath)}
                                    </span>
                                  </div>
                                )}

                                {idx === 2 && attachmentsToUse.length > 3 && (
                                  <div className="attachment-overlay">
                                    <span className="overlay-text">
                                      +{attachmentsToUse.length - 3}
                                    </span>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </Image.PreviewGroup>
                    </div>
                    {/* )} */}
                  </>
                )}
              </div>
            );
          })}
        </div>

        <ChangeStatusModal
          loading={isUpdating}
          mode={
            openRejectModal ? "rejected" : openParkedModal ? "parked" : "parked"
          }
          open={openRejectModal || openParkedModal || changeStatusModalOpen}
          onClose={() => {
            setChangeStatusModalOpen(false);
            setOpenRejectModal(false);
            setOpenParkedModal(false);
          }}
          onConfirm={({ status, description }) => {
            updateTicketStatusMutate(
              {
                service_ticket_no: ticketData.service_ticket_no,
                status: Number(status),
                comments: description || "",
              },
              {
                onSuccess: (res) => {
                  message.success(
                    res.message || "Ticket status updated successfully"
                  );
                  setChangeStatusModalOpen(false);
                  setOpenRejectModal(false);
                  setOpenParkedModal(false);
                  refetchTickets();
                },
                onError: () => {
                  message.error("Failed to update ticket status");
                },
              }
            );
          }}
        />
        <AcceptTicket
          ticketData={ticketData}
          open={acceptTicketOpen}
          description="Review the details and update the requested bin quantity if needed before confirming."
          onClose={() => setAcceptTicketOpen(false)}
          onConfirm={handleApproval}
          requestedQty={requestedQty}
          approvedQty={approvedQty}
          loading={isApproving}
          onRequestedChange={(v) => setRequestedQty(v)}
          onApprovedChange={(v) => setApprovedQty(v)}
          setIsPaymentRequired={setIsPaymentRequired}
          isPaymentRequired={isPaymentRequired}
        />
        {openReinitiateModal && (
          <ConfirmModal
            open={openReinitiateModal}
            loading={isUpdating}
            title="Re-initiate ticket"
            message="You are about to re-initiate this parked ticket. It will return to Open status."
            confirmText="Re-initiate"
            onClose={() => setOpenReinitiateModal(false)}
            onConfirm={() => {
              updateTicketStatusMutate(
                {
                  service_ticket_no: ticketData.service_ticket_no,
                  status: 10,
                  comments: "",
                },
                {
                  onSuccess: (res) => {
                    message.success(
                      res.message || "Ticket re-initiated successfully"
                    );
                    setOpenReinitiateModal(false);
                    refetchTickets();
                  },
                  onError: () => {
                    message.error("Failed to re-initiate ticket");
                  },
                }
              );
            }}
          />
        )}
        {assignConfirmOpen && (
          <ConfirmModal
            open={assignConfirmOpen}
            loading={isAssigning}
            title="Assign ticket"
            message={`You are about to assign selected ticket.`}
            confirmText="Assign"
            onClose={() => setAssignConfirmOpen(false)}
            onConfirm={() => {
              assignTicketMutate(
                {
                  pikitup_ticket_ids: [Number(ticketData.pikitup_ticket_id)],
                },
                {
                  onSuccess: (res) => {
                    message.success(
                      res.message || "Tickets assigned successfully"
                    );
                    setAssignConfirmOpen(false);
                    setSelectedRowKeys([]);
                    refetchTickets();
                  },
                  onError: (err: any) => {
                    message.error(
                      err?.response?.data?.message ||
                        "Failed to assign tickets. Please try again."
                    );
                  },
                }
              );
            }}
          />
        )}
        {/* {shouldShowComments && (
          <div className="comments-section mt-6">
            <h4 className="details-card-heading mb-2">Comments</h4>

            {/* <div className="add-comment mb-4">
                     comment section
                    </div> */}
        {/* <span className="secondary-heading">Previous comments</span>
            <div className="previous-comments flex flex-col gap-4">
              {comments.map((comment, idx) => (
                <div key={idx} className="comment-card flex flex-col">
                  <div className="name-wrapper flex items-center gap-2">
                    <span className="commented-user ">{comment.author}</span>
                    <span className="date">{comment.date}</span>
                  </div>
                  <p className="comment">{comment.content}</p>
                </div>
              ))}
            </div>
          </div> */}
        {/* )} } */}
        {/* Reject Modal */}
      </div>
      <ServiceRequestDrawer
        open={servicedrawerOpen}
        setOpen={setServiceDrawerOpen}
        serviceHistory={serviceHistory}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        selectedAccount={selectedAccount}
        setSelectedAccount={setSelectedAccount}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <ContractServicesDrawer
        open={ContactServicesDrawer}
        setOpen={setContactDrawerOpen}
        pikitupServices={pikitupServices}
        pikitupMeta={pikitupMeta}
      />
    </div>
  );
};

export default LeftSection;
